import { Injectable, OnDestroy } from '@angular/core';
import {
  EquisModalDialogService,
  IEquisModalDialogConfig as ModalConfig,
} from '@tn-equis/core/components/modal-dialog';

import { ModalDownloadAppComponent as ModalComponent } from './modal-download-app/modal-download-app.component';
import { IModalDownloadApp } from './button-download-app.types';
import { PlatformService } from '../../services/platform.service';
import { Text } from '../../types/contentful';
import { ButtonDownloadDialogs } from './button-download-dialogs';
import { Subject, takeUntil } from 'rxjs';

@Injectable()
export class ButtonDownloadAppService implements OnDestroy {
  constructor(
    private modalDialogService: EquisModalDialogService,
    private platform: PlatformService,
  ) {}

  // PROPERTIES
  // This property is set by the component that receives the data from contentful
  // and is later used by the modal to display the texts and images.
  dialogData!: IModalDownloadApp;
  private destroyed$ = new Subject<void>();

  // METHODS
  /**
   * Shows the modal dialog.
   * @param title Header title
   */
  public show(title: Text): void {
    const customConfig: ModalConfig =
      ButtonDownloadDialogs.createDownloadAppDialog(title);
    this.modalDialogService
      .showModalDialog(customConfig, ModalComponent)
      .pipe(takeUntil(this.destroyed$))
      .subscribe();
  }

  /**
   * Closes the modal dialog.
   */
  public close(): void {
    this.modalDialogService.closeModalDialog({});
  }

  /**
   * Shows the modal dialog with the given state.
   * @param state Dialog state to show
   */
  public showStateDialog(state: 'success' | 'retry' | 'error'): any {
    const config = {
      success: ButtonDownloadDialogs.SUCCESS_DIALOG,
      retry: ButtonDownloadDialogs.RETRY_DIALOG,
      error: ButtonDownloadDialogs.ERROR_DIALOG,
    };

    return this.modalDialogService.showModalDialog(config[state]);
  }

  /**
   * Redirects the user to the app. This must only be done on mobile devices (like Android or iOS devices)
   */
  public redirectToApp(link: string): void {
    if (this.platform.isMobile) {
      window.open(link, '_blank');
    }
  }

  ngOnDestroy(): void {
    this.destroyed$?.next();
    this.destroyed$?.complete();
  }
}
